import { render, staticRenderFns } from "./ModalChangeAccount.vue?vue&type=template&id=669c6ad3&"
import script from "./ModalChangeAccount.vue?vue&type=script&lang=js&"
export * from "./ModalChangeAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports